import { BaseUrlFormatter } from "../../../base";
export class MultiEventUrlFormatter extends BaseUrlFormatter {
    composeEndpoint(request) {
        let endpoint = "";
        if (request.categoryId && request.subCategoryId) {
            endpoint = `v1/leagues/${request.leagueId}/categories/${request.categoryId}/subcategories/${request.subCategoryId}`;
        }
        else if (request.categoryId) {
            endpoint = `v1/leagues/${request.leagueId}/categories/${request.categoryId}`;
        }
        else {
            endpoint = `v1/leagues/${request.leagueId}`;
        }
        return endpoint;
    }
}
//# sourceMappingURL=MultiEventUrlFormatter.js.map